import React from 'react';
import { Form, Input, Avatar, Typography } from 'antd';
import type { FormInstance } from 'antd';
import type { PartyMember } from '../../types/types';
import styles from './CharacterSheetModal.module.css';

const { Title } = Typography;

interface CharacterSheetHeaderProps {
  player: PartyMember | null;
  playerImage: { imageUrl: string } | null | undefined;
  form: FormInstance;
}

const CharacterSheetHeader: React.FC<CharacterSheetHeaderProps> = ({ player, playerImage, form }) => {
  if (!player) return null;

  return (
    <>
      <Form.Item name="name" noStyle>
        <Input bordered={false} className={styles.titleInput} />
      </Form.Item>
      <Avatar shape="square" size={200} src={playerImage?.imageUrl} style={{ backgroundColor: player?.color ?? undefined, fontSize: '5rem' }}>
        {form.getFieldValue('name')?.charAt(0) ?? '?'}
      </Avatar>
      <Title level={4} style={{ textAlign: 'center', margin: '0.5rem 0 0 0' }}>
        {player?.className ?? 'Adventurer'}, Level {player?.level ?? 1}
      </Title>
    </>
  );
};

export default CharacterSheetHeader;